export default {
  QUICK_TRADE: 'QuickTrade',
  DEPOSIT_ACH: 'DepositACH',
  DEPOSIT_WIRE: 'DepositWire',
  DEPOSIT_CRYPTO: 'DepositCrypto',
  TRADE: 'Trade',
  PLAID: 'Plaid',
  FUNDING_PASSWORD: 'FundingPassword',
};
